import { Outlet } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { MySessionsDatatable } from 'modules/trainings/components/TrainingDetail/Sessions/MySessionsDatatable'

const Sessions = () => {
  return (
    <Box>
      <MySessionsDatatable action={Action} />
      <Outlet />
    </Box>
  )
}

function Action({ id }: { id: string }) {
  const { trainingId } = useStrictParams<'trainingId'>()
  const { navigation } = useNavigation()
  return (
    <Box alignItems="flexEnd" flexDirection="row">
      <Button.Router
        type="secondary"
        to={navigation.myTrainings.revamp.detailsRevamp.view.sessions.sidepanel.fullPath({
          trainingId: String(trainingId),
          sessionId: id,
        })}
        iconName="arrow-right"
      />
    </Box>
  )
}

export default Sessions
